export default function Authority() {
  const teses = [
    { icon: "ri-file-damage-line", label: "Nulidade da CDA", desc: "Vícios formais e materiais na Certidão de Dívida Ativa" },
    { icon: "ri-timer-line", label: "Prescrição", desc: "Dívidas fiscais com prazo expirado não podem ser cobradas" },
    { icon: "ri-close-circle-line", label: "Cobrança indevida", desc: "Tributos lançados sem base legal ou em valor incorreto" },
    { icon: "ri-building-line", label: "Empresa inativa", desc: "Tributos cobrados de CNPJ inativo ou encerrado irregularmente" },
    { icon: "ri-map-pin-line", label: "Taxas municipais irregulares", desc: "Cobranças de taxas sem correspondência com serviço prestado" },
    { icon: "ri-scales-line", label: "Excesso de execução", desc: "Valor cobrado superior ao que efetivamente é devido" },
    { icon: "ri-alert-line", label: "Vícios no crédito tributário", desc: "Falhas no processo administrativo de constituição do débito" },
  ];

  return (
    <section className="bg-white">
      {/* Execução Fiscal como Autoridade Técnica */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3">
              Profundidade técnica na defesa
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">
              Quando o bloqueio decorre de execução fiscal,<br className="hidden md:block" />
              a defesa do processo é essencial
            </h2>
            <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
              Em execuções fiscais, há teses jurídicas específicas que podem suspender a cobrança ou anular o crédito tributário por inteiro. 
              O escritório atua com domínio técnico em cada uma delas.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
            {teses.slice(0, 4).map((tese, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 hover:border-amber-400 transition-colors duration-200">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${tese.icon} text-xl text-amber-600`}></i>
                </div>
                <h3 className="text-gray-900 font-semibold text-sm mb-2">{tese.label}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{tese.desc}</p>
              </div>
            ))}
          </div>
          <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {teses.slice(4).map((tese, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 hover:border-amber-400 transition-colors duration-200">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${tese.icon} text-xl text-amber-600`}></i>
                </div>
                <h3 className="text-gray-900 font-semibold text-sm mb-2">{tese.label}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{tese.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dr. Gabriel Araújo */}
      <div id="sobre" className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/bbb32f62fa49874c503b49ff6a2b85c0/bed28be04cf40b5119678c7715f7dd70.png"
                alt="Gabriel Araújo - Advogado Especialista em Desbloqueio Judicial"
                className="rounded-2xl w-full max-w-md mx-auto object-cover object-top"
              />
            </div>

            <div>
              <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-3">
                Quem vai cuidar do seu caso
              </p>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Dr. Gabriel Araújo<br />
                <span className="text-amber-400">Advocacia Personalizada</span>
              </h2>

              <div className="bg-gray-800 p-6 rounded-xl mb-8 border-l-4 border-amber-500">
                <p className="text-gray-300 text-base leading-relaxed">
                  Advogado com atuação especializada em <strong className="text-white">desbloqueio de contas judiciais, Direito Tributário e Execuções Fiscais</strong>. 
                  Defende empresas e pessoas físicas contra bloqueios indevidos e cobranças irregulares, com análise técnica individualizada em cada caso.
                </p>
              </div>

              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-shield-check-line text-amber-400 text-xl"></i>
                  </div>
                  <span className="text-gray-300 text-sm">OAB/SP 433.002</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-graduation-cap-line text-amber-400 text-xl"></i>
                  </div>
                  <span className="text-gray-300 text-sm">Especialista em Direito Tributário e Execuções Fiscais</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    <i className="ri-award-line text-amber-400 text-xl"></i>
                  </div>
                  <span className="text-gray-300 text-sm">Atendimento personalizado e estratégia jurídica específica por caso</span>
                </div>
              </div>

              <blockquote className="bg-gray-800 border border-gray-700 rounded-xl p-6">
                <p className="text-gray-300 text-sm leading-relaxed italic">
                  &quot;Minha atuação começa pela análise técnica do processo. Identificar se o bloqueio é legal, se os valores são protegidos e quais medidas cabíveis existem — isso é o que faz a diferença para o cliente.&quot;
                </p>
                <p className="text-amber-400 text-xs font-semibold mt-3">— Dr. Gabriel Araújo</p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
